import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA
} from '@angular/core';
import { LanguageSelectorModule } from '../../common/language-selector/language-selector.module';
import { UnsupportedBrowserModule } from '../../common/unsupported-browser/unsupported-browser.module';
import { AppLinksContentMobileContainerModule } from '../app-links-content-mobile-container/app-links-content-mobile-container.module';
import { AppNavigationLinksModule } from '../app-navigation-links/app-navigation-links.module';
import { BusinessUserModule } from '../business-user/business-user.module';
import { LoginModule } from '../login/login.module';
import { LogoModule } from '../logo/logo.module';
import { NavigationBookModule } from '../navigation-book/navigation-book.module';
import { NavigationCheckinModule } from '../navigation-checkin/navigation-checkin.module';
import { NotificationModule } from '../notification/notification.module';
import { SearchModule } from '../search/search.module';
import { SwitchingAccountModule } from '../switching-account/switching-account.module';
import { NgcGlobalNavSlimComponent } from './global-nav-slim.component';

@NgModule({
  imports: [
    CommonModule,
    LoginModule,
    NotificationModule,
    SearchModule,
    NavigationBookModule,
    BusinessUserModule,
    SwitchingAccountModule,
    LogoModule,
    UnsupportedBrowserModule,
    LanguageSelectorModule,
    AppNavigationLinksModule,
    AppLinksContentMobileContainerModule,
    NavigationCheckinModule
  ],
  declarations: [NgcGlobalNavSlimComponent],
  exports: [NgcGlobalNavSlimComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class NgcSlimHeaderModule {}
